//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import orderCreatable from "~/mixins/orderCreateable.js";

export default {
  mixins: [orderCreatable],

  props: {
    content: {
      required: true,
    },
  },
};
